import { BaseModifyRequest } from "./baseModifyRequest";
import { Customer } from "../customers/customer";
/**
 * Created by alex.y on 10/12/2017.
 */
export class CustomerModifyRequest extends BaseModifyRequest {
    public Customer: Customer;

    public constructor(obj?: Partial<CustomerModifyRequest>) {
        super();
        Object.assign(this, obj);
    }
}


// WEBPACK FOOTER //
// ./app/objects/requests/customerModifyRequest.ts